const locales = [
  {
    locale: 'en',
    messages: import('./en'),
  },
  {
    locale: 'ru',
    messages: import('./ru'),
  },
  {
    locale: 'de',
    messages: import('./de'),
  },
]

export default locales
